import React, { Component } from 'react'
import EntityList from './../../components/entityList';

class DoorRestraints extends Component {
  render() {
    return (
      <EntityList apiRoute='api/doorrestraints' title='Remorque - Retient-portes' editTitle='Retient-porte' displayColumns={[
        {Description: 'Description', Column: 'Description'},
        {Description: 'Inactif', Column: 'Inactive', sortable: false, format: {type: 'boolean'}}
      ]}/>
    )
  }
}

export default DoorRestraints;


/** WEBPACK FOOTER **
 ** ./src/app/routes/trailers/doorRestraints.js
 **/